/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { ConversationalAgentStateSchemaDetail } from './ConversationalAgentStateSchemaDetail';
import {
  ConversationalAgentStateSchemaDetailFromJSON,
  ConversationalAgentStateSchemaDetailFromJSONTyped,
  ConversationalAgentStateSchemaDetailToJSON,
} from './ConversationalAgentStateSchemaDetail';

/**
 *
 * @export
 * @interface ConversationalAgentDataset
 */
export interface ConversationalAgentDataset {
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof ConversationalAgentDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {ConversationalAgentStateSchemaDetail}
   * @memberof ConversationalAgentDataset
   */
  readonly stateSchema: ConversationalAgentStateSchemaDetail;
  /**
   *
   * @type {boolean}
   * @memberof ConversationalAgentDataset
   */
  evaluateState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ConversationalAgentDataset
   */
  readonly hasState: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ConversationalAgentDataset
   */
  readonly hasTokenUsage: boolean;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof ConversationalAgentDataset
   */
  language: ConversationalAgentLanguageEnum;
}

/**
 * Check if a given object implements the ConversationalAgentDataset interface.
 */
export function instanceOfConversationalAgentDataset(value: object): value is ConversationalAgentDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('stateSchema' in value) || value['stateSchema'] === undefined) return false;
  if (!('hasState' in value) || value['hasState'] === undefined) return false;
  if (!('hasTokenUsage' in value) || value['hasTokenUsage'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function ConversationalAgentDatasetFromJSON(json: any): ConversationalAgentDataset {
  return ConversationalAgentDatasetFromJSONTyped(json, false);
}

export function ConversationalAgentDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    stateSchema: ConversationalAgentStateSchemaDetailFromJSON(json['state_schema']),
    evaluateState: json['evaluate_state'] == null ? undefined : json['evaluate_state'],
    hasState: json['has_state'],
    hasTokenUsage: json['has_token_usage'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
  };
}

export function ConversationalAgentDatasetToJSON(
  value?: Omit<
    ConversationalAgentDataset,
    'id' | 'hasPredictions' | 'stateSchema' | 'hasState' | 'hasTokenUsage'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    evaluate_state: value['evaluateState'],
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
  };
}
